import { useAuth } from '@/hooks/useAuth'
import { getAuthConfig } from '@/services/auth/config'

/**
 * Placeholder serverId sent by the cloud-tenant publish UI. The backend's
 * `resolvePublishTarget` IGNORES the client serverId on cloud+tenant and forces
 * the managed central-PG Server doc — this value only exists to satisfy the
 * `serverId: z.string().min(1)` request schema. Never resolved to a real doc.
 */
export const CLOUD_MANAGED_SERVER_PLACEHOLDER = 'gisify-cloud-managed'

/**
 * Pure predicate: is this caller a cloud SaaS tenant (so publishing is confined
 * to the operator-managed central database, no server picker)?
 *
 * - cloud (provider 'cognito') + a tenantId → true
 * - cloud central operator (no tenantId) → false (full BYOS)
 * - on-prem (provider 'keycloak') → false (full BYOS)
 */
export function isCloudTenantTarget(args: {
  provider: 'cognito' | 'keycloak' | undefined
  tenantId: string | undefined | null
}): boolean {
  return args.provider === 'cognito' && !!args.tenantId
}

/** Hook wrapper — reads auth + provider and returns the cloud-tenant flag. */
export function useCloudTenantTarget(): boolean {
  const { user } = useAuth()

  let provider: 'cognito' | 'keycloak' | undefined

  try {
    provider = getAuthConfig().provider
  } catch {
    // getAuthConfig throws before loadAuthConfig() resolves — default to cloud,
    // matching SettingsSidebar's defensive handling.
    provider = 'cognito'
  }

  return isCloudTenantTarget({ provider, tenantId: user?.tenantId })
}
